export default function () {
  return [
    {
      title: '获得日期',
      [$field]: 'rewardDate',
      isEdit: true,
      width: 150,
      props: {
        type: 'date'
      },
      showType: 'datePicker'
    },
    {
      title: '颁发组织',
      isEdit: true,
      [$field]: 'awardOrganization'
    },
    {
      title: '所获荣誉',
      isEdit: true,
      [$field]: 'rewardTitle'
    },
    {
      'title': '操作',
      'width': 120,
      [$field]: 'operate',
      'isOperate': true
    }
  ]
}
